import { request } from './index'

// userId: 372926198601142210    管理员Id: 10061730
// 查看主题-外协人员
export const getThemeView = (params) => request({
    url: '/theme/viewThemeByOutsideUser',
    method: 'post',
    params,
})

//查看主题下的知识点 XXXX
export const getKnowledge = (params) => request({
    url: '/knowledge/view',
    method: 'post',
    params
})

// 外协人员-查看知识点下视频
export const getStudyList = (params) => request({
    url: '/study/viewTestList',
    method: 'post',
    params
})

// 查看知识点-外协人员
export const getKnowlegeByOutsideUser = (params) => request({
    url: '/theme/viewKnowledgeByOutsideUser',
    method: 'post',
    params
})

// 外协用户-查看知识点下视频信息
export const getVideo = (params) => request({
    url: '/video/viewVideoOfKnowledge',
    method: 'post',
    params
})

//外协人员-我要考试--生成考试试卷
export const getQuestion = (params) => request({
    url: '/study/testMe',
    method: 'post',
    params
})

//外协人员-答题－－Y：回答正确，N：回答错误
export const getAnswer = (params) => request({
    url: '/study/answer',
    method: 'post',
    params
})

//外协人员-增加学习记录。增加或者更新记录
export const updateRecord = (params) => request({
    url: '/study/record',
    method: 'post',
    params
})

//外协人员-增加学习记录。增加或者更新记录
export const queryRecord = (params) => request({
    url: '/study/queryVideoRecord',
    method: 'post',
    params
})

// 人脸验证
export const faceComparison = (params) => request({
    url: '/user/faceValidate',
    method: 'post',
    params
})

// 根据知识点答题完查看成绩
export const checkAnswer = (params) => request({
    url: '/study/result',
    method: 'post',
    params
})

// 查询所有部门信息
export const getDepts = (params) => request({
    url: '/user/viewDept',
    method: 'post',
    params
})

// 外协人员更新自己的部门信息
export const updateDept = (params) => request({
    url: '/user/updateDept',
    method: 'post',
    params
})

// 获取当前用户信息
export const getCurrentUserInfo = () => request({
    url: '/user/getUserInfoPC',
    method: 'post',
})

// 查询公司级条线信息
export const getLine = () => request({
    url: '/user/viewLine',
    method: 'post'
})

// 外协人员更新自己条线信息
export const updateLine = (params) => request({
    url: '/user/updateLine',
    method: 'post',
    params
})